// extracted by mini-css-extract-plugin
module.exports = {"orderInfo":"_6_donationResult_orderInfo_1TjAj","warningInfo":"_6_donationResult_warningInfo_tYIw5","text":"_6_donationResult_text_33ZLG"};